import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';

import { Main, Filter } from 'Containers';
import { DirtyWrapper, LoadingPage } from 'Components';
import { submitForm, resetForm } from 'State/forms/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { errorToast } from 'Common/ToastHelper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { CreateEditPrepWorksheetEnum } from 'Common/FieldEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME } from 'Common/FormEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import {
  CreateEditKitchenPrepWorksheetEnum,
  KitchenPrepSaveTypeEnum,
  StatusDescEnum,
} from 'Common/Constants/Enumeration/KitchenPrepWorksheet';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';

import {
  BASE_URL,
  prepareSaveKitchenPrepPayload,
} from '../../helper/createEditPrepWorksheet';
import * as actions from './../../state/createEditKitchenPrepWorksheet/actions';
import { CreateEditKitchenPrepWorksheetForm } from '../../containers/createEditKitchenPrepWorksheet/CreateEditKitchenPrepWorksheetContainer';
import * as Selectors from './../../state/createEditKitchenPrepWorksheet/selectors';

const currentDate = moment();
class CreateEditKitchenPrepWorksheetContainer extends Component {
  static path = `${BASE_URL}/:IsNewEdit/:TransactionId/:DeliveryDate/:KitchenId`;
  state = {
    activeIndexForFilter: GenericEnum.InitialFilterValue,
    sorted: [],
    filtered: [],
    page: 0,
    OpType: KitchenPrepSaveTypeEnum.SaveOnly,
  };

  componentDidMount() {
    const {
      IsNewEdit,
      TransactionId,
      DeliveryDate,
      KitchenId,
    } = this.props.match.params;
    if (IsNewEdit === CreateEditKitchenPrepWorksheetEnum.EDIT) {
      this.props.getKitchenPrepDetails(TransactionId);
    }
    const reqObj = {
      DeliveryDate: DeliveryDate,
      KitchenId: KitchenId,
    };
    if (DeliveryDate && KitchenId) {
      this.props.getKitchenPrepWorksheetItems(reqObj);
    }
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    if (
      errorToast(this.props, prevProps, 'fetchKitchenItemListError') ||
      errorToast(this.props, prevProps, 'fetchingKitchenPrepDetailError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      this.props.clearKitchenErrors();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Kitchen Prep Worksheet has been saved.',
        true
      );
      this.props.clearKitchenErrors();
      this.props.history.push(`${BASE_URL}`);
      this.props.resetDirty();
    }
  }

  componentWillUnmount() {
    this.completeReset();
    this.props.emptyKitchenItemList();
    if (this.props.selectedKitchenPrepData) {
      this.props.emptyEditObject();
    }
  }

  getFilterdData = (deliveryDT, selectedKitchen) => {
    const { getKitchenPrepWorksheetItems } = this.props;
    const reqObj = {
      DeliveryDate: moment(deliveryDT).format(DATE_FORMAT_FOR_SERVER),
      KitchenId: selectedKitchen,
    };
    deliveryDT && selectedKitchen && getKitchenPrepWorksheetItems(reqObj);
  };

  getMainProps = showDirtyConfirm => {
    const { selectedKitchenPrepData } = this.props;
    if (
      selectedKitchenPrepData &&
      selectedKitchenPrepData.StatusDesc === StatusDescEnum.Closed
    ) {
      return {
        toolbox: {
          backButtonProps: { shown: true, path: `${BASE_URL}` },
          shown: true,
        },
      };
    } else {
      return {
        toolbox: {
          rightButtons: [
            {
              content: 'Update On Hand and Close',
              onClick: this.onUpdateAndCloseClick,
              disabled: !this.isTableDataValid(),
            },
            {
              content: 'Update On Hand and Keep Open',
              onClick: this.onUpdateAndLeaveOpenClick,
              disabled: !this.isKeepOpenEnabled(),
            },
            {
              content: 'Save Only',
              onClick: this.onSaveButtonClick,
              disabled: !this.isTableDataValid(),
            },
            {
              content: 'Cancel',
              onClick: showDirtyConfirm,
            },
          ],
          shown: true,
        },
      };
    }
  };

  isTableDataValid = () => {
    const { kitchenPrepWorksheetInfo } = this.props;
    let data = [];
    if (kitchenPrepWorksheetInfo && kitchenPrepWorksheetInfo.length) {
      data = kitchenPrepWorksheetInfo.filter(item => {
        return item.PreparedPrimary || item.PreparedSecondary;
      });
    }
    return Boolean(data.length);
  };

  isKeepOpenEnabled = () => {
    const { kitchenPrepWorksheetInfo, kitchenItems } = this.props;

    let isKeepOpenEnabled = false;
    if (
      kitchenPrepWorksheetInfo &&
      kitchenPrepWorksheetInfo.length &&
      kitchenItems &&
      kitchenItems.length
    ) {
      isKeepOpenEnabled = kitchenPrepWorksheetInfo.some(currentItem => {
        const originalItem = kitchenItems.find(originalItem => {
          return originalItem.ItemCode === currentItem.ItemCode;
        });
        if (
          originalItem &&
          (currentItem.PreparedPrimary !== GenericEnum.EmptyString ||
            currentItem.PreparedSecondary !== GenericEnum.EmptyString)
        ) {
          if (
            (currentItem.PreparedPrimary &&
              currentItem.PreparedPrimary < originalItem.NeededPrimary) ||
            (currentItem.PreparedSecondary &&
              currentItem.PreparedSecondary < originalItem.NeededSecondary)
          ) {
            isKeepOpenEnabled = true;
          }
        }

        return isKeepOpenEnabled;
      });
    }
    return isKeepOpenEnabled;
  };

  onSaveButtonClick = () => {
    this.setState({
      OpType: KitchenPrepSaveTypeEnum.SaveOnly,
    });
    this.props.submitForm(CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME);
  };

  onUpdateAndCloseClick = () => {
    if (this.props.neededQtyDiff.length) {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title: 'Kitchen Prep Worksheet',
        question: `The following item(s) did not meet the needed amount : \n${
          this.props.neededQtyDiff
        }\nDo you wish to continue?`,
        yesCallback: () => this.handleShowWarningBeforeSave(true),
        noCallback: () => this.handleShowWarningBeforeSave(false),
      });
    } else {
      this.setState({
        OpType: KitchenPrepSaveTypeEnum.UpdateOnHandAndClose,
      });
      this.props.submitForm(CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME);
    }
  };

  onUpdateAndLeaveOpenClick = () => {
    this.setState({
      OpType: KitchenPrepSaveTypeEnum.UpdateOnHandAndLeaveOpen,
    });
    this.props.submitForm(CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME);
  };

  handleSubmit = values => {
    const { IsNewEdit, TransactionId } = this.props.match.params;
    const id =
      IsNewEdit === CreateEditKitchenPrepWorksheetEnum.NEW
        ? GenericEnum.ZeroString
        : TransactionId;
    this.props.saveKitchenPrepWorksheet(
      prepareSaveKitchenPrepPayload(values, this.state.OpType, id)
    );
  };

  getBreadCrumbs = () => {
    const { IsNewEdit } = this.props.match.params;
    const { selectedKitchenPrepData } = this.props;
    return [
      {
        title: 'Kitchen Prep Worksheet',
        link: `${BASE_URL}`,
      },
      {
        title:
          IsNewEdit === CreateEditKitchenPrepWorksheetEnum.NEW
            ? 'Create New'
            : selectedKitchenPrepData &&
              selectedKitchenPrepData.StatusDesc === StatusDescEnum.Closed
              ? 'View Kitchen Items'
              : 'Edit Kitchen Items',
        link: '',
      },
    ];
  };

  clearFilters = () => {
    const { DeliveryDate, KitchenId } = this.props.match.params;
    this.setState({
      sorted: [],
      filtered: [],
      page: 0,
    });
    const deliveryDate = DeliveryDate
      ? DeliveryDate
      : currentDate.format(DATE_FORMAT_FOR_SERVER);
    const kitchenId = KitchenId ? KitchenId : GenericEnum.EmptyString;
    this.getFilterdData(deliveryDate, kitchenId);
    if (!this.props.selectedKitchenPrepData) {
      this.props.emptyKitchenItemList();
    }
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME);
  };

  handleClick = () => {
    this.setState({
      activeIndexForFilter: !this.state.activeIndexForFilter,
    });
  };

  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted, page: 0 });
  };

  onFilteredChange = (filtered, column) => {
    this.setState({ filtered, page: 0 });
  };

  onPageChange = page => {
    this.setState({ page });
  };

  dropDownChange = selectedKitchen => {
    this.getFilterdData(this.props.selectedDeliveryDT, selectedKitchen);
  };

  onChangeOfDeliveryDT = (e, deliveryDate) => {
    this.getFilterdData(deliveryDate, this.props.selectedKitchen);
  };

  handleShowWarningBeforeSave = result => {
    if (result) {
      this.setState({
        OpType: KitchenPrepSaveTypeEnum.UpdateOnHandAndClose,
      });
      this.props.submitForm(CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME);
    }
  };

  onCancelClick = () => {
    this.props.history.push(`${BASE_URL}`);
  };

  getCreatePageOrEditPage = () => {
    const { IsNewEdit, DeliveryDate, KitchenId } = this.props.match.params;
    const { activeIndexForFilter, sorted, filtered, page } = this.state;
    let element = [];
    let initialValues = {};
    let render = false;
    if (IsNewEdit === CreateEditKitchenPrepWorksheetEnum.EDIT) {
      const { selectedKitchenPrepData, kitchenItems } = this.props;
      if (selectedKitchenPrepData) {
        render = true;
        initialValues = {
          [CreateEditPrepWorksheetEnum.DeliveryDT]: moment(
            selectedKitchenPrepData[CreateEditPrepWorksheetEnum.DeliveryDT]
          ).format(DATE_FORMAT_FOR_UI),
          [CreateEditPrepWorksheetEnum.Kitchen]:
            '' + selectedKitchenPrepData[CreateEditPrepWorksheetEnum.KitchenId],
          [CreateEditPrepWorksheetEnum.Comments]:
            selectedKitchenPrepData[CreateEditPrepWorksheetEnum.Comments],
          [CreateEditPrepWorksheetEnum.KitchenPrepWorksheetInfo]: kitchenItems,
        };
      }
    } else {
      render = true;
      initialValues = {
        [CreateEditPrepWorksheetEnum.DeliveryDT]: DeliveryDate
          ? moment(DeliveryDate).format(DATE_FORMAT_FOR_UI)
          : currentDate.format(DATE_FORMAT_FOR_UI),
        [CreateEditPrepWorksheetEnum.Kitchen]: KitchenId
          ? KitchenId
          : GenericEnum.EmptyString,
        [CreateEditPrepWorksheetEnum.Comments]: GenericEnum.EmptyString,
        [CreateEditPrepWorksheetEnum.KitchenPrepWorksheetInfo]: [],
      };
    }
    if (render) {
      const {
        kitchenItems,
        neededQtyDiff,
        loading,
        isDisabled,
        isEditDisabled,
      } = this.props;
      element.push(
        <CreateEditKitchenPrepWorksheetForm
          key={`createEditPage`}
          activeIndexForFilter={activeIndexForFilter}
          handleClick={this.handleClick}
          sorted={sorted}
          onSortedChange={this.onSortedChange}
          filtered={filtered}
          onFilteredChange={this.onFilteredChange}
          page={page}
          onPageChange={this.onPageChange}
          dropDownChange={this.dropDownChange}
          clearFilters={this.clearFilters}
          kitchenItems={kitchenItems}
          onChangeOfDeliveryDT={this.onChangeOfDeliveryDT}
          handleShowWarningBeforeSave={this.handleShowWarningBeforeSave}
          neededQtyDiff={neededQtyDiff}
          loading={loading}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          disabled={isDisabled}
          isEditDisabled={isEditDisabled}
        />
      );
    }
    return element;
  };

  render() {
    const { fetchingKitchenPrepDetail, isReadOnly } = this.props;
    return fetchingKitchenPrepDetail ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter
          title={''}
          breadcrumbs={this.getBreadCrumbs()}
          style={{
            width: 600,
          }}
        />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageOrEditPage()}
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const selector = formValueSelector(
  CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME
);
const mapStateToProps = (state, props) => {
  const { IsNewEdit } = props.match.params;
  const selectedKitchenPrepData = Selectors.getSelectedKitchenPrepData(state);
  const isDisabled =
    selectedKitchenPrepData &&
    selectedKitchenPrepData.StatusDesc === StatusDescEnum.Closed &&
    IsNewEdit === CreateEditKitchenPrepWorksheetEnum.EDIT;
  const isEditDisabled =
    selectedKitchenPrepData &&
    IsNewEdit === CreateEditKitchenPrepWorksheetEnum.EDIT;

  return {
    kitchenItems: Selectors.getKitchenPrepItems(state),
    neededQtyDiff: Selectors.getNeededPreparedQtyDiff(state),
    loading: Selectors.getListLoading(state),
    fetchKitchenItemListError: Selectors.getKitchenItemListError(state),
    submitted: Selectors.getSubmitted(state),
    submitError: Selectors.getSubmitError(state),
    kitchenPrepSubmitLoading: Selectors.getKitchenPrepSubmitLoading(state),
    fetchingKitchenPrepDetailError: Selectors.getKitchenPrepDetailError(state),
    fetchingKitchenPrepDetail: Selectors.getKitchenPrepDetailLoading(state),
    selectedKitchenPrepData: selectedKitchenPrepData,
    selectedKitchen: selector(state, CreateEditPrepWorksheetEnum.Kitchen),
    selectedDeliveryDT: selector(state, CreateEditPrepWorksheetEnum.DeliveryDT),
    comments: selector(state, CreateEditPrepWorksheetEnum.Comments),
    kitchenPrepWorksheetInfo: selector(state, [
      CreateEditPrepWorksheetEnum.KitchenPrepWorksheetInfo,
    ]),
    isDisabled: isDisabled,
    isEditDisabled: isEditDisabled,
  };
};

const mapDispatchToProps = {
  ...actions,
  resetForm,
  submitForm,
  resetDirty,
  setYesNoDialogProps,
};

export const CreateEditKitchenPrepWorksheet = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditKitchenPrepWorksheetContainer);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/containers/createEditKitchenPrepWorksheet/CreateEditKitchenPrepWorksheet.js